var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPokeSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 588,
    height: 600,
    viewBox: "0 0 588 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_3225",
    "data-name": "\\u9577\\u65B9\\u5F62 3225",
    width: 588,
    height: 600,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30A2\\u30FC\\u30C8\\u30EF\\u30FC\\u30AF_56",
    "data-name": "\\u30A2\\u30FC\\u30C8\\u30EF\\u30FC\\u30AF 56",
    transform: "translate(294 300)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_16635",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 16635",
    transform: "translate(-294 -300)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_98440",
    "data-name": "\\u30D1\\u30B9 98440",
    d: "M306.741,2a228,228,0,0,0-188,356l-104,102.667A52,52,0,0,0,88.074,534L193.408,428.667A228,228,0,1,0,306.741,2",
    transform: "translate(26.592 24.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_98441",
    "data-name": "\\u30D1\\u30B9 98441",
    d: "M306.741,2a228,228,0,0,0-188,356l-104,102.667A52,52,0,0,0,88.074,534L193.408,428.667A228,228,0,1,0,306.741,2Z",
    transform: "translate(26.592 24.667)",
    fill: "none",
    stroke: "#333",
    strokeLinejoin: "round",
    strokeWidth: 40
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_98442",
    "data-name": "\\u30D1\\u30B9 98442",
    d: "M136.193,10.207a118.667,118.667,0,1,0,117.333,120A118.667,118.667,0,0,0,134.86,11.54",
    transform: "translate(199.807 125.793)",
    fill: "#333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_98443",
    "data-name": "\\u30D1\\u30B9 98443",
    d: "M136.193,10.207a118.667,118.667,0,1,0,117.333,120,118.667,118.667,0,0,0-117.333-120Z",
    transform: "translate(199.807 125.793)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 53.333
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_98444",
    "data-name": "\\u30D1\\u30B9 98444",
    d: "M122.533,62.667A50.667,50.667,0,0,1,73.2,20h-56a106.667,106.667,0,0,0,212,0h-56a50.667,50.667,0,0,1-49.333,42.667",
    transform: "translate(212.133 246.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_98445",
    "data-name": "\\u30D1\\u30B9 98445",
    d: "M123.767,63.486A50.667,50.667,0,0,1,173.1,106.153h56a106.667,106.667,0,0,0-212,0h56a50.667,50.667,0,0,1,49.333-42.667",
    transform: "translate(210.9 140.514)",
    fill: "#e40b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_98446",
    "data-name": "\\u30D1\\u30B9 98446",
    d: "M57.267,16.6A34.667,34.667,0,1,0,91.933,51.267,34.667,34.667,0,0,0,57.267,16.6",
    transform: "translate(278.733 204.733)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPokeSearch);
export default __webpack_public_path__ + "static/media/poke_search.a6e20f5006131129e9211484687ea625.svg";
export { ForwardRef as ReactComponent };